document.addEventListener('click', function (event) {
  document.querySelectorAll('.mobile-menu[open]').forEach(function (menu) {
    if (!menu.contains(event.target)) menu.removeAttribute('open');
  });
});
document.addEventListener('keydown', function (event) {
  if (event.key === 'Escape') document.querySelectorAll('.mobile-menu[open]').forEach(function (menu) { menu.removeAttribute('open'); });
});

document.addEventListener('click', function (event) {
  var thumb = event.target.closest('[data-gallery-thumb]');
  if (!thumb) return;
  var gallery = thumb.closest('.product-gallery');
  if (!gallery) return;
  var index = thumb.getAttribute('data-gallery-thumb');
  gallery.querySelectorAll('[data-gallery-slide]').forEach(function (slide) {
    slide.classList.toggle('is-active', slide.getAttribute('data-gallery-slide') === index);
  });
  gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (item) {
    item.classList.toggle('is-active', item === thumb);
  });
});
